module.exports = __webpack_public_path__ + "img/job--interview.3595ac3b.svg";